import { useContext } from "react";
import { Grid } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import FormTable, {
  FormTableHeader,
} from "../../../common/components/functional/formTable/FormTable";
import { Talent, talentIsDeactivated } from "../../talents/talentAPI";
import { removeCvDocument, selectTalentById } from "../../talents/talentsSlice";
import { AccessRightContext } from "../../user/AccessRightProvider";
import { useParams } from "react-router-dom";
import { TALENT_CV_PREFIX } from "../../../common/helpers/regexes";
import { ContentKey } from "../TalentDetails";
import { useTranslation } from "react-i18next";

type Props = {
  handleOpenEditModal: (content: ContentKey) => void;
};

export const TalentCVTable = ({ handleOpenEditModal }: Props) => {
  const { t } = useTranslation("talentProfile");
  const { canEditTalentProfile } = useContext(AccessRightContext);
  const { talentId } = useParams();
  const talent = useAppSelector(
    (state) => selectTalentById(state, talentId as string) as Talent,
  );
  const cv = talent?.cv;
  const headers: FormTableHeader[] = [{ text: t("common:name") }];
  const addButtonLabel = canEditTalentProfile && !cv ? t("addCV") : null;

  const data = cv
    ? [
        {
          id: cv.filename,
          values: {
            fileName: cv.filename.match(TALENT_CV_PREFIX)
              ? cv.filename.slice(52)
              : cv.filename,
          },
          deletable: canEditTalentProfile,
        },
      ]
    : [];

  const dispatch = useAppDispatch();

  const handleDelete = () => {
    if (!cv) return;
    dispatch(removeCvDocument({ talentId: talent.id, pathspec: cv.pathspec }));
  };

  return (
    <Grid container columnSpacing={2}>
      <Grid
        item
        container
        xs={3}
        justifyContent="flex-end"
        alignItems="center"
      />
      <Grid item xs={5}>
        <FormTable
          data={data}
          headers={headers}
          contentKey="cv"
          translationKeys={["talentProfile"]}
          handleOpenEditModal={handleOpenEditModal}
          addButtonLabel={addButtonLabel}
          disableEditRow={!canEditTalentProfile || talentIsDeactivated(talent)}
          handleDelete={handleDelete}
        />
      </Grid>
    </Grid>
  );
};
